import React, { Component } from 'react';
import ProgressBar from './ProgressBar';

class Languages extends Component {

    state ={
        languages: [
            {id: 1, value: "HTML", xp:1.8},
            {id: 2, value: "CSS", xp:1.8},
            {id: 3, value: "PHP", xp:0.7},
            {id: 4, value: "Javascript", xp:1.6}

        ],
        frameworks: [
            {id: 1, value: "React" , xp:1.5},
            {id: 2, value: "Bootstrap" , xp:1.8},
            {id: 3, value: "Sass" , xp:1.3}
        ]
    }
    render() {
        let {languages, frameworks} = this.state;
        return (
            <div className='languagesFrameworks'>
              <ProgressBar
                languages={languages}
                className="languagesDisplay"
                title="languages"
              />

              <ProgressBar
              languages={frameworks}
              title="frameworks & bibliothèques"
              className="frameworksDisplay" 
              /> 
            </div>
        );
    }
}

export default Languages;